import { SyncOutlined } from "@ant-design/icons";
import axios from "axios";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { riderSchema } from "../../components/validation/Schema";
import { addDispatch } from "../../redux/admin/actions/admin.actions";
import style from "./Update.module.scss";

const CreateForm = (props) => {
  const dispatch = useDispatch();
  const baseUrl = "https://lab.lifebank.ng/labx/api/v1/auth/user/state/Nigeria";

  const [stateOptionDropDown, setstateOptionDropDown] = useState();
  const [selectedState, setSelectedState] = useState();
  const [riderType, setRiderType] = useState();
  const [riderState, setRiderState] = useState();

  useEffect(() => {
    const fetchData = () => {
      axios.get(baseUrl).then((response) => {
        let options = response?.data?.states
          .sort((a, b) => (a?.name > b.name ? -1 : 1))
          .map((state) => ({
            label: state.name,
            value: state.name,
          }));
        setstateOptionDropDown(options);
      });
    };
    fetchData();
  }, []);

  const riders = [
    {
      label: "LifeBanker",
      value: "LifeBanker",
    },
    {
      label: "3PL",
      value: "3PL",
    },
  ];

  return (
    <>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          bike_id: "",
          dispatch_id: "",
        }}
        validationSchema={riderSchema}
        onSubmit={(values, actions) => {
          const findSelectedStateLabel = stateOptionDropDown.filter(
            // eslint-disable-next-line eqeqeq
            (state) => state.value == selectedState
          );

          values.State = findSelectedStateLabel[0].label;
          values.RiderType = riderType;
          values.operational = riderState;
          dispatch(addDispatch(values, actions));
          props.onClickYes();
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleSubmit,
          isSubmitting,
          handleBlur,
        }) => (
          <Form onSubmit={handleSubmit}>
            <h3 className="text-danger text-center">ADD DISPATCH</h3>
            <Row className="mt-4 col-md-12">
              <Col className="mb-4" sm={12} md={12} xl={6}>
                <Form.Control
                  type="text"
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder="First Name"
                  name="first_name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.first_name || ""}
                />
                {errors.first_name && touched.first_name ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.first_name}
                  </p>
                ) : null}
              </Col>
              <Col sm={12} md={12} xl={6}>
                <Form.Control
                  type="text"
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder="Last Name"
                  name="last_name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.last_name || ""}
                />
                {errors.last_name && touched.last_name ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.last_name}
                  </p>
                ) : null}
              </Col>
            </Row>

            <Row className="mt-4 col-md-12">
              <Col className="mb-4" sm={12} md={12} xl={6}>
                <Form.Control
                  type="text"
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder="Bike ID"
                  name="bike_id"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.bike_id || ""}
                />
                {errors.bike_id && touched.bike_id ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.bike_id}
                  </p>
                ) : null}
              </Col>
              <Col sm={12} md={12} xl={6}>
                <Form.Control
                  type="text"
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder="Dispatch ID"
                  name="dispatch_id"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // value={values?.dispatch_id || ""}
                />
                {errors.dispatch_id && touched.dispatch_id ? (
                  <p className={`${style.errorMessage} text-danger mt-1 mx-2`}>
                    {errors.dispatch_id}
                  </p>
                ) : null}
              </Col>
            </Row>

            <Row className="mt-4 col-md-12">
              <Col className="mb-4" sm={12} md={12} xl={12}>
                <select
                  className={`${style.formInput} shadow-none form-control`}
                  placeholder="State of Origin"
                  name="State"
                  // onChange={(option) => loadStateLGAOption(option)}
                  values={values.State}
                  onChange={(e) => {
                    const selectedStateId = e.currentTarget.value;
                    setSelectedState(selectedStateId);
                  }}
                  required
                >
                  <option>Select State</option>
                  {stateOptionDropDown
                    ?.sort((a, b) => (a?.label > b?.label ? 1 : -1))
                    ?.map((stateOption) => {
                      return (
                        <option
                          value={stateOption?.value}
                          label={stateOption?.label}
                          key={stateOption?.value}
                        >
                          {stateOption?.label}
                        </option>
                      );
                    })}
                </select>
              </Col>
            </Row>

            <Row className="mt-4 col-md-12">
              <Col className="mb-4" sm={12} md={12} xl={12}>
                <select
                  className={`${style.formInput} shadow-none form-control`}
                  onChange={(e) => setRiderType(e.target.value)}
                  required
                >
                  <option>Select Rider Type</option>
                  {riders?.map((riderType) => {
                    return (
                      <option
                        value={riderType?.value}
                        label={riderType?.label}
                        key={riderType?.value}
                      >
                        {riderType?.label}
                      </option>
                    );
                  })}
                </select>
              </Col>
            </Row>

            {/* Conditionally render Rider State dropdown */}
            {riderType === "3PL" && (
              <Row className="mt-4 col-md-12">
                <Col className="mb-4" sm={12} md={12} xl={12}>
                  <select
                    className={`${style.formInput} shadow-none form-control`}
                    onChange={(e) => setRiderState(e.target.value)}
                    required
                  >
                    <option>Select Operational State</option>
                    {stateOptionDropDown
                      ?.sort((a, b) => (a?.label > b?.label ? 1 : -1))
                      ?.map((stateOption) => {
                        return (
                          <option
                            value={stateOption?.value}
                            label={stateOption?.label}
                            key={stateOption?.value}
                          >
                            {stateOption?.label}
                          </option>
                        );
                      })}
                  </select>
                </Col>
              </Row>
            )}

            <Row>
              <div className="d-flex justify-content-center mt-3">
                <button
                  type="submit"
                  className={` shadow-none  ${style.actionBtn} ${style.reject}`}
                  style={{ background: props.btnColor }}
                >
                  {isSubmitting || props.loading ? (
                    <SyncOutlined spin />
                  ) : (
                    "SUBMIT"
                  )}
                </button>
              </div>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateForm;
